import React from "react";
import { styled } from '@mui/material/styles';
import contentStyles from './ContentStyles';
import CheckIcon from '@mui/icons-material/Check';
import Separator from "../Separator/Separator";

type ContentProps = {
  title: string;
  description: string;
};

const StyledContent = styled('section')(({ theme }) => contentStyles(theme));

const leftImg = 'https://grupogm-assets.s3.us-east-1.amazonaws.com/content/hidalgo2.webp';
const rightImg = 'https://grupogm-assets.s3.us-east-1.amazonaws.com/content/hidalgo1.webp';

const contentClassNames =  {
    contentContainer: "gap-16 items-center py-20 px-8 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-32 lg:px-6",
    contentInnerContainer: "gap-16 font-light",
    contentTitle: "mb-4 text-4xl tracking-tight font-semibold pb-6 md:pb-6",
    contentSubtitle: "pb-10 lg:pb-0",
    contentImgContainer: "grid grid-cols-2 gap-4",
    contentLeftImg: "w-full rounded-lg aspect-[3/4] object-cover",
    contentRightImg: "mt-4 w-full lg:mt-10 rounded-lg aspect-[3/4] object-cover"
  }

const Content: React.FC<ContentProps> = ({ title, description }) => (
  <StyledContent>
    <div className={contentClassNames.contentContainer}>
        <div className={contentClassNames.contentInnerContainer}>
          <h2 id="content-title" className={contentClassNames.contentTitle}>{title}</h2>
          <div className="my-4">
            <div className="flex">
              <Separator className="mb-10"/>
            </div>
            <div className="text-lg">{description}</div>
          </div>
          <p id="content-description" className={contentClassNames.contentSubtitle}>
            <ul className="text-lg font-light">
              <li className="font-light"><CheckIcon /> Pachuca</li>
              <li className="font-light"><CheckIcon /> Tulancingo</li>
              <li className="font-light"><CheckIcon /> Tula</li>
              <li className="font-light"><CheckIcon /> Tizayuca</li>
              <li className="font-light"><CheckIcon /> Tepeji del Río</li>
              <li className="font-light"><CheckIcon /> Ixmiquilpan</li>
            </ul>
          </p>
        </div>
        <div className={contentClassNames.contentImgContainer}>
          <img loading="lazy" className={contentClassNames.contentLeftImg} src={leftImg} alt="content left" />
          <img loading="lazy" className={contentClassNames.contentRightImg} src={rightImg} alt="content right" />
        </div>
      </div>
  </StyledContent>
);

export default Content;